const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email) => {
  if (!email) return false;
  const cleaned = email.trim().toLowerCase();
  return EMAIL_REGEX.test(cleaned);
};

export const getEmailError = (email) => {
  if (!email || !email.trim()) return 'Email is required';
  const e = email.trim();
  if (!e.includes('@')) return 'Email must contain @';
  if (e.includes(' ')) return 'Email cannot contain spaces';
  const [local, domain] = e.split('@');
  if (!local) return 'Invalid email format';
  if (!domain || !domain.includes('.')) return 'Invalid email domain';
  if (/[<>(){}\[\]\\,;:\s"'!#$&*/=?^`|~]/.test(local)) return 'Email contains invalid characters';
  if (!EMAIL_REGEX.test(e)) return 'Invalid email format';
  return null;
};
